export var RecursiveMenuMode = /*#__PURE__*/function (RecursiveMenuMode) {
  RecursiveMenuMode["full"] = "full";
  RecursiveMenuMode["breadcrumb"] = "breadcrumb";
  RecursiveMenuMode["intranet"] = "intranet";
  return RecursiveMenuMode;
}({});

// Max Menu only.